"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetClientReport = void 0;
const Base_1 = require("./Base");
exports.GetClientReport = {
    url: Base_1.URL_BASE + "/GetClientsReport",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetClientReport.js.map